import { BaseCamelCasedResource, paramsToString } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class ConnectedLiensOverviewResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.connectedLiens = [];
    }
    pk() {
        return "ConnectedLienEngagement";
    }
    static url(urlParams) {
        return `${this.urlRoot}${paramsToString(urlParams)}`;
    }
}
ConnectedLiensOverviewResource.urlRoot = legacyApiResourceUrl("CustomerEngagement/ConnectedLienEngagement");
export { ConnectedLiensOverviewResource };
//# sourceMappingURL=ConnectedLiensOverviewResource.js.map